import React from 'react';
import { Switch, Route } from 'react-router-dom';
import SubscriptionContainer from '../containers/subscription';
import SubscriptionConfirmation from '../components/subscription/subscription_confirmation';
import CancelSubscription from '../containers/cancel_subscription';

export default class Subscription extends React.Component {
  render() {
    return(
      <Switch>
        <Route path="/subscription/cancel" component={ CancelSubscription } />
        <Route path="/subscription/confirmation" component={ SubscriptionConfirmation } />
        <Route path="/subscription" component={ SubscriptionContainer } />
      </Switch>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/subscription.jsx